import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BlogPage() {
  const blogRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!blogRef.current) return;

    const container = blogRef.current;
    // Clear any previous embed
    container.innerHTML = '';

    // Create the soro-blog div
    const blogDiv = document.createElement("div");
    blogDiv.id = "soro-blog";
    container.appendChild(blogDiv);

    // Build script URL with post param if present
    const params = new URLSearchParams(window.location.search);
    let scriptUrl = "https://app.trysoro.com/api/embed/da16f294-3d42-4bf6-90b3-f4ba704a26bf";
    if (params.get("post")) {
      scriptUrl += "?post=" + encodeURIComponent(params.get("post"));
    }

    // Inject the script
    const script = document.createElement("script");
    script.src = scriptUrl;
    script.async = true;
    container.appendChild(script);

    return () => {
      container.innerHTML = '';
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <nav className="fixed top-0 left-0 right-0 z-50 glass">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 text-slate-800 hover:text-orange-500 transition-colors font-semibold text-lg"
            data-testid="blog-back-home"
          >
            <ArrowLeft className="w-5 h-5" />
            Transport Anything 247
          </button>
          <div className="flex items-center gap-6">
            <a href="/" className="nav-link">Home</a>
            <a href="tel:+447757133163" className="hidden sm:flex items-center gap-2 text-orange-500 font-medium">
              +44 7757 133163
            </a>
          </div>
        </div>
      </nav>

      {/* Blog Content */}
      <main className="pt-24 pb-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <div ref={blogRef} data-testid="blog-embed-container" className="min-h-[60vh]" />
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-8 text-center text-sm">
        &copy; {new Date().getFullYear()} Transport Anything 247. All rights reserved.
      </footer>
    </div>
  );
}
